<template>
<div style="margin:0 auto;width: 460px;background: #fff;height: 100%" >
    <div class="mt-4">
   <el-form ref="form" :model="form" label-width="100px"  :rules="rules">
           
            
                    <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0">
                      <div class="d-flex"> 
                         <el-autocomplete v-model="form.mem_id" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect" class="w-75"></el-autocomplete>
                           
                            <el-select v-if="form.habu!=''" v-model="form.habu"  :placeholder="$t('status.선택')"  style="width:120px;margin-left: 5px;">
                             <el-option
                                v-for="item in couponOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select>
                      </div>
                     
                        
                    </el-form-item>
                 
                    <el-form-item :label="$t('newAdd.쿠폰금액')" prop="money" class="mb-0">
                        <el-input v-model="form.money"></el-input>
                    </el-form-item>
                  <el-form-item :label="$t('newAdd.사용조건')" prop="condition" class="mb-0">
                        <el-input v-model="form.condition" style="width:100px;margin-right:10px" placeholder="입금금액"></el-input>{{$t('newAdd.입금')}}
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.만기일')" prop="end_time" class="mb-0">
                       <el-date-picker
                          v-model="form.end_time"
                          type="date" value-format="yyyy-MM-dd"
                         >
                        </el-date-picker>
                      </el-form-item>
                   
                   <el-form-item v-if="this.sim!='1'" :label="$t('newAdd.머니구분')" class="mb-0" prop="money_type">
                     <el-radio-group v-model="form.money_type" size="small">
                       
                        <el-radio :label="2" border>{{$t('msg.카슬머니')}}</el-radio>
                         <el-radio :label="1" v-if="this.power=='1'" border>{{$t('msg.파워머니')}}</el-radio>
                         <el-radio :label="3" border>{{$t('newAdd.알머니')}}</el-radio>
                     </el-radio-group>
                      <el-tooltip  placement="bottom">
                         <div slot="content">{{$t('newAdd.일반회원은가슬머니또는파워머니가능')}}<br/>{{$t('newAdd.파트너는알머니만가능합니다')}}</div>
                            <el-button type="danger" icon="el-icon-question" style="background: transparent;color: #000;margin-left:5px;font-size: 18px !important;border:none;padding:0"></el-button>
                      </el-tooltip>

                    </el-form-item>

                     <el-form-item v-if="this.sim=='1'" :label="$t('newAdd.머니구분')" class="mb-0" prop="money_type">
                     <el-radio-group v-model="form.money_type" size="small">
                       
                       
                         <el-radio :label="3" border>{{$t('msg.게임머니')}}</el-radio>
                     </el-radio-group>
                      <el-tooltip  placement="bottom">
                         
                            <el-button type="danger" icon="el-icon-question" style="background: transparent;color: #000;margin-left:5px;font-size: 18px !important;border:none;padding:0"></el-button>
                      </el-tooltip>

                    </el-form-item>

                     <el-form-item :label="$t('newAdd.쿠폰유형')"  class="mb-0">
                      
                         
                            <el-select  v-model="form.sty"  :placeholder="$t('status.선택')"  style="width:120px;">
                             <el-option
                                v-for="item in styOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select>
                     
                     
                        
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.비고')" prop="doc" class="mb-0">
                        <el-input
                            type="textarea"
                            :rows="4"
                            v-model="form.doc">
                          </el-input>
                      </el-form-item>
                

          </el-form>
          <span slot="footer" class="dialog-footer float-right mt-2">
              <el-button @click="cancel">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit" :loading="couponLoad">{{$t('msg.확인')}}</el-button>
          </span>
      </div>
</div>
 </template>

 <script>
 
    export default {
   
       props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      //  bets:{
      //   type:Array,
      //   default:()=>{
      //     return {}
      //   }
      // },
     
      // gameProvider:{
      //   type:String,
      //   default:""
      // },
    
      //  banker_cards:{
      //   type:Array,
      //   default:()=>[]
        
      // },
       layerid:{
        type:String,
        default:""
      },
      
    },
    	data(){
    		return{
                couponLoad:false,
    			domain:window.sessionStorage.getItem('domain'),
                power:window.sessionStorage.getItem('power'),
                 styOptions:[  
           {
              label:this.$i18n.t("newAdd.가입쿠폰"),
              value:'1'
            },
            {
              label:this.$i18n.t("newAdd.이벤트쿠폰"),
              value:'2'
            },
            {
              label:this.$i18n.t("newAdd.감사쿠폰"),
              value:'3'
            },
            {
              label:this.$i18n.t("newAdd.등급업쿠폰"),
              value:'4'
            },
            {
              label:this.$i18n.t("newAdd.기타"),
              value:'5'
            },
            ],

       form:{
           money_type:'',
           id:'',
           mem_id:'',
           moeny:'',
           end_time:'',
           doc:'',
          condition:'',
         
            habu:'0',
            sty:'1',
          },
          rules: {
                
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  money:[{ required: true, message: '', trigger: 'blur'}],
                  end_time:[{ required: true, message: '', trigger: 'blur'}],
                  doc:[{ required: true, message: '', trigger: 'blur'}],
                  money_type:[{ required: true, message: '', trigger: 'blur'}],
                  condition:[{ required: true, message: '', trigger: 'blur'}],
                },
          couponOptions:[  
           {
              label:this.$i18n.t("newAdd.본인"),
              value:'0'
            },
            {
              label:this.$i18n.t("newAdd.하부회원"),
              value:'1'
            },
            ],
    			}
    			
    			
    		},
    		created() {
        
          console.log('id',this.info.id)
          this.form.mem_id = this.info.id
         
    },
    	
    	methods:{
          
    	
 querySearchAsync(queryString, cb) {
       let token=window.sessionStorage.getItem('user');
           
              this.$axios({
                    method:'put',
                    url:this.domain+'/admin/id_like?mem_id='+this.form.mem_id,
                   
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

               let item = response.data.data.data;

               this.restaurants = item;
                   // return this.restaurants;

                  var restaurants = this.restaurants;
                 //console.log('restaurants==',restaurants)
                          // 解决element建议搜索框无法显示内容 的数据处理
                          for (var i = 0; i < restaurants.length; i++) {
                            restaurants[i].value = restaurants[i].mem_id;
                          }
                          var results = queryString
                            ? restaurants.filter(this.createStateFilter(queryString))
                            : restaurants;
                          // 调用 callback 返回建议列表的数据
                          clearTimeout(this.timeout);
                          this.timeout = setTimeout(() => {
                            cb(results);
                          }, 500 * Math.random());
                                      
   
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                   
              })
 
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.mem_id.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

      handleSelect(item) {
        console.log('item',item.mem_id);
        this.form.mem_id = item.mem_id;
      },
         
    	cancel(){
             this.$layer.close(this.layerid);
        },
    	submit(){
             
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;

              this.couponLoad =true 
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/coupon_insert',
                        data:{
                        
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          money:this.form.money,
                          end_time:this.form.end_time,
                          doc:this.form.doc,
                          money_type:this.form.money_type,
                          condition:this.form.condition,
                          habu:this.form.habu,
                          sty:this.form.sty

                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         this.couponLoad = false
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message.success(response.data.msg);
                               //console.log(this.form);
                             //  this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                               this.$layer.close(this.layerid);

                            }
                           // this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
//this.loading =false
                  })
              
           
            })
              
            
        },	
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>

>>>.el-radio{
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/common/coupon.vue